import React from 'react';
import { TextCursorInput } from 'lucide-react';
import { useTranslation } from '../../../i18n';

const InputFieldElement = ({ element, isEditor = false, value = '', onChange, disabled = false }) => {
  const { t } = useTranslation();
  const { content, style } = element;
  const { placeholder, inputType, maxLength } = content;
  // The outer wrapper (SlideCanvas / VirtualClassroom) already paints
  // element.style.backgroundColor, so the inner preview/input stays transparent —
  // this keeps the editor and lesson looking identical for whatever color the
  // teacher picked.
  const bgHex = (style?.backgroundColor || '').trim();
  const isDarkBg = (() => {
    const m = bgHex.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
    if (!m) return false;
    const h = m[1].length === 3 ? m[1].split('').map(c => c + c).join('') : m[1];
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) < 140;
  })();
  const placeholderTextColor = isDarkBg ? '#EDECE9' : '#9ca3af';

  if (isEditor) {
    return (
      <div
        className="w-full h-full flex items-center justify-center border-2 border-dashed rounded-lg px-3"
        style={{ backgroundColor: 'transparent', borderColor: '#2A4D25' }}
      >
        <TextCursorInput size={16} className="mr-2 flex-shrink-0" style={{ color: isDarkBg ? '#EDECE9' : '#2A4D25' }} />
        <span className="text-sm truncate" style={{ color: placeholderTextColor }}>{placeholder || t('games.inputField.placeholder')}</span>
      </div>
    );
  }

  if (inputType === 'textarea') {
    return (
      <textarea
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        className="w-full h-full px-3 py-2 border-2 rounded-lg resize-none focus:outline-none focus:ring-2 focus:border-transparent text-sm"
        style={{ backgroundColor: disabled ? '#f3f4f6' : 'transparent', color: isDarkBg ? '#EDECE9' : '#1f2937', borderColor: '#2A4D25', '--tw-ring-color': '#2A4D25' }}
      />
    );
  }

  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
      disabled={disabled}
      className="w-full h-full px-3 border-2 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent text-sm"
      style={{ backgroundColor: disabled ? '#f3f4f6' : 'transparent', color: isDarkBg ? '#EDECE9' : '#1f2937', borderColor: '#2A4D25', '--tw-ring-color': '#2A4D25' }}
    />
  );
};

export default InputFieldElement;
